import { Logger } from "../utils/logger";

export class LazyLoadObserver {
    private observer: IntersectionObserver;

    constructor() {
        this.observer = new IntersectionObserver(this.handleIntersect, {
            rootMargin: "100px", // Früheres Laden für sanfte Übergänge
            threshold: 0.1,       // Erst aktiv, wenn 10% sichtbar sind
        });
    }

    /**
     * Manuelles Hinzufügen eines Elements mit individuellem Callback
     */
    observe(element: HTMLElement, onLoad: () => void) {
        element.dataset.lazyLoaded = "false";
        (element as any)._lazyLoadCallback = onLoad;
        this.observer.observe(element);
    }

    /**
     * Automatisch alle Standard-Lazy-Elemente beobachten
     * (z.B. alle mit data-lazy="true")
     */
    observeDefaults() {
        const defaultElements = document.querySelectorAll<HTMLElement>('[data-lazy="true"]');
        defaultElements.forEach((el) => {
            this.observe(el, () => {
                const event = new CustomEvent("lazyload", { detail: el });
                el.dispatchEvent(event);
                Logger.debug("[LazyLoadObserver] Default Lazyload ausgelöst für Element", el);
            });
        });
    }

    /**
     * Intersektion-Callback
     */
    private handleIntersect = (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
        entries.forEach((entry) => {
            const targetElement = entry.target as HTMLElement;

            if (entry.isIntersecting && targetElement.dataset.lazyLoaded === "false") {
                const callback = (targetElement as any)._lazyLoadCallback;

                if (typeof callback === "function") {
                    Promise.resolve(callback()).catch((err) => {
                        Logger.error("[LazyLoadObserver] Fehler im Lazy-Callback", err);
                    });
                }

                targetElement.dataset.lazyLoaded = "true";
                observer.unobserve(targetElement);
                Logger.debug("[LazyLoadObserver] Element lazy-geladen und Beobachtung beendet", targetElement);
            }
        });
    };
}

export const lazyLoadObserver = new LazyLoadObserver();